export interface SelectData {
  label?: string;
  value: any;
}
